import { render, staticRenderFns } from "./v-access-now.vue?vue&type=template&id=86dd3bda&"
import script from "./v-access-now.vue?vue&type=script&lang=js&"
export * from "./v-access-now.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports